import { render, staticRenderFns } from "./platformCostData.vue?vue&type=template&id=561465d5&scoped=true"
import script from "./platformCostData.vue?vue&type=script&lang=js"
export * from "./platformCostData.vue?vue&type=script&lang=js"
import style0 from "./platformCostData.vue?vue&type=style&index=0&id=561465d5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561465d5",
  null
  
)

export default component.exports